import styled from 'styled-components';
import { Typography } from '@karma/components';

export const AlertTitle = styled(Typography)`
  width: ${({ $isMobile }) => ($isMobile ? '236px' : '294px')};
  text-overflow: ellipsis;
  overflow: hidden;
`;
